import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { last } from 'rxjs/operators';
import { Campaign } from 'src/app/models/communication/campaign';
import { Employer } from 'src/app/models/employer';
import { DataService } from 'src/app/services/data.service';
import { SiteService } from 'src/app/services/site.service';

@Component({
  selector: 'app-campaigns',
  templateUrl: './campaigns.component.html',
  styleUrls: ['./campaigns.component.scss']
})
export class CampaignsComponent {

	public campaigns: Array<Campaign> = [];
	public employers: Array<Employer> = [];
	public emailTypeOptions = [
		{ label: 'All', value: 0 },
		{ label: 'Single', value: 1 },
		{ label: 'Drip', value: 2 },
	]
	public dateRangeOptions = [
		{ label: 'All', value: 0 },
		{ label: '30 Days', value: 30 },
		{ label: '90 Days', value: 90 },
		{ label: '6 Months', value: 180 },
		{ label: '1 Year', value: 365 },
	]

	public selectedEmployer: Employer;
	public dateRange: any = 30;
	public emailType: any = 1;

	// Sorting properties
	public sortColumn: string = '';
	public sortDirection: 'asc' | 'desc' = 'asc';

	constructor(private dataService: DataService, private siteService: SiteService, private router: Router) { }

	ngOnInit() {
		this.siteService.pageTitle = 'Campaigns';
		
		// Restore filter state if it exists
		const savedState = this.siteService.campaignFilterState;
		if (savedState.dateRange !== undefined) {
			this.dateRange = savedState.dateRange;
		}
		if (savedState.emailType !== undefined) {
			this.emailType = savedState.emailType;
		}
		
		this.dataService.getEmployers().subscribe((data) => {
			this.employers = data;
			this.employers.unshift(new Employer({ employerID: '', employerName: 'All Employers' }));
			
			// Restore selected employer after employers are loaded
			if (savedState.selectedEmployer) {
				this.selectedEmployer = this.employers.find(e => e.employerID === savedState.selectedEmployer?.employerID) || this.employers[0];
			}
			
			// Load campaigns with saved filters or defaults
			this.filterCampaigns();
		});
		
		this.siteService.headerButtons = [
			{ text: 'Add New', class: 'success', callback: () => this.addNew() },
		];
	}

	addNew() {
		this.router.navigate(['/admin/campaigns/new']);
	}

	filterCampaigns() {
		// Save current filter state
		this.siteService.campaignFilterState = {
			selectedEmployer: this.selectedEmployer,
			dateRange: this.dateRange,
			emailType: this.emailType
		};
		
		this.dataService.getCampaigns(this.selectedEmployer?.employerID, this.dateRange.value, this.emailType.value).subscribe((data) => {
			this.campaigns = data;
			// Apply current sorting after filtering
			if (this.sortColumn) {
				this.sortCampaigns(this.sortColumn, false);
			}
		});
	}

	sortCampaigns(column: string, toggleDirection: boolean = true) {
		// Toggle direction if clicking the same column
		if (toggleDirection) {
			if (this.sortColumn === column) {
				this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
			} else {
				this.sortDirection = 'asc';
			}
		}
		
		this.sortColumn = column;

		this.campaigns.sort((a, b) => {
			let valueA: any;
			let valueB: any;

			switch (column) {
				case 'name':
					valueA = a.campaignName?.toLowerCase() || '';
					valueB = b.campaignName?.toLowerCase() || '';
					break;
				case 'employer':
					valueA = a.employer?.toLowerCase() || '';
					valueB = b.employer?.toLowerCase() || '';
					break;
				case 'subject':
					valueA = a.eMailSubject?.toLowerCase() || '';
					valueB = b.eMailSubject?.toLowerCase() || '';
					break;
				case 'type':
					valueA = a.emailTypeDesc?.toLowerCase() || '';
					valueB = b.emailTypeDesc?.toLowerCase() || '';
					break;
				case 'start':
					valueA = new Date(a.deliveryDateTime || 0);
					valueB = new Date(b.deliveryDateTime || 0);
					break;
				case 'status':
					valueA = a.campaignStatusDesc?.toLowerCase() || '';
					valueB = b.campaignStatusDesc?.toLowerCase() || '';
					break;
				default:
					return 0;
			}

			if (valueA < valueB) {
				return this.sortDirection === 'asc' ? -1 : 1;
			}
			if (valueA > valueB) {
				return this.sortDirection === 'asc' ? 1 : -1;
			}
			return 0;
		});
	}

	getSortIcon(column: string): string {
		if (this.sortColumn !== column) {
			return 'sort';
		}
		return this.sortDirection === 'asc' ? 'sort-up' : 'sort-down';
	}
}
